import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useTmpMemberSearchForm = () => {
  // 絞込み条件
  const searchConditionName = ref<string | undefined | null>(null);
  const searchConditionPhone = ref<string | undefined | null>(null);
  const searchConditionZipCode = ref<string | undefined | null>(null);

  return {
    searchConditionName,
    searchConditionPhone,
    searchConditionZipCode,
  };
};
